// Admin: modelo de card de cada fila do Whaticket (campos, etapas e como concluir).
// Fila sem modelo usa o card do suporte (O.S, QRA, protocolo).
import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  Button, Checkbox, Chip, FormControlLabel, Grid, IconButton, MenuItem, Paper, Switch, TextField, Tooltip,
  Typography, makeStyles,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import { useHistory } from "react-router-dom";

import ConfirmationModal from "../../components/ConfirmationModal";
import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import suporteApi, { mensagemErro } from "../api";

const useStyles = makeStyles((theme) => ({
  papel: { padding: 16, overflowY: "auto", flex: 1, ...theme.scrollbarStyles },
  campo: { border: `1px solid ${theme.palette.divider}`, borderRadius: 8, padding: "8px 10px", marginBottom: 8 },
}));

const TIPOS = [["texto", "Texto"], ["paragrafo", "Texto longo"], ["numero", "Número"], ["data", "Data"],
  ["email", "E-mail"], ["telefone", "Telefone"], ["lista", "Lista (escolher de uma lista)"]];
const ORIGENS = [["", "O atendente preenche"], ["contato_nome", "Nome do contato no WhatsApp"],
  ["contato_numero", "Número do WhatsApp"]];
const VAZIO = { nome: "", campos: [], lista_etapas: "", etapas_finais: [], ativo: true, fluxo: null };

// Fluxo de formulários: cada fase manda um formulário (escolhido pelo valor de um campo, ex.: modalidade),
// agradece quando o contato responde e avança a etapa.
const novaFase = () => ({ nome: "", quando: "abrir", etapa: "", formularios: {}, mensagem: "", agradecimento: "", etapa_ao_responder: "" });

const EditorFluxo = ({ m, setM, etapas, formularios }) => {
  const c = useStyles();
  const fluxo = m.fluxo || { campo: "", fases: [] };
  const campoChave = m.campos.find((cp) => cp.id && cp.id === fluxo.campo);
  const [valores, setValores] = useState([]);
  useEffect(() => {
    if (!campoChave?.lista) return setValores([]);
    suporteApi.get(`/api/listas/${campoChave.lista}`).then((r) => setValores(r.data.filter((x) => x.ativo).map((x) => x.nome)))
      .catch(() => setValores([]));
  }, [campoChave?.lista]);
  const mudar = (d) => setM({ ...m, fluxo: { ...fluxo, ...d } });
  const mudarFase = (i, d) => mudar({ fases: fluxo.fases.map((f, j) => (j === i ? { ...f, ...d } : f)) });
  const chaves = campoChave ? valores : ["*"];
  return (
    <div style={{ marginTop: 16 }}>
      <Typography variant="subtitle1">Fluxo de formulários</Typography>
      <Typography variant="caption" color="textSecondary" component="div" style={{ marginBottom: 8 }}>
        Cada fase manda um formulário pelo WhatsApp (ligado ao card), agradece quando o contato responde e avança a etapa.
        Nas mensagens, use {"{nome}"}, {"{formulario}"} e {"{link}"}.
      </Typography>
      <TextField select fullWidth size="small" variant="outlined" label="Campo que escolhe o formulário" value={fluxo.campo || ""}
        onChange={(e) => mudar({ campo: e.target.value || null })}
        helperText="Ex.: Modalidade — CLT recebe um formulário, PJ outro. Sem campo: o mesmo formulário para todos.">
        <MenuItem value="">Nenhum (mesmo formulário para todos)</MenuItem>
        {m.campos.filter((cp) => cp.id && cp.tipo === "lista").map((cp) => <MenuItem key={cp.id} value={cp.id}>{cp.rotulo}</MenuItem>)}
      </TextField>
      {fluxo.fases.map((f, i) => (
        <div key={i} className={c.campo} style={{ marginTop: 8 }}>
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={12} sm={5}>
              <TextField fullWidth size="small" variant="outlined" label={`Fase ${i + 1}`} placeholder="Ex.: Fase 1 – Triagem"
                value={f.nome} onChange={(e) => mudarFase(i, { nome: e.target.value })} />
            </Grid>
            <Grid item xs={6} sm={3}>
              <TextField select fullWidth size="small" variant="outlined" label="Enviar" value={f.quando}
                onChange={(e) => mudarFase(i, { quando: e.target.value })}>
                <MenuItem value="abrir">Ao abrir o card</MenuItem>
                <MenuItem value="etapa">Ao entrar na etapa…</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={6} sm={4} style={{ textAlign: "right" }}>
              <Tooltip title="Remover fase"><IconButton size="small" onClick={() => mudar({ fases: fluxo.fases.filter((_, j) => j !== i) })}><DeleteOutlineIcon fontSize="small" /></IconButton></Tooltip>
            </Grid>
            {f.quando === "etapa" && (
              <Grid item xs={12}>
                <TextField select fullWidth size="small" variant="outlined" label="Etapa que dispara o envio" value={f.etapa || ""}
                  onChange={(e) => mudarFase(i, { etapa: e.target.value })}>
                  {etapas.map((et) => <MenuItem key={et} value={et}>{et}</MenuItem>)}
                </TextField>
              </Grid>
            )}
            {chaves.map((v) => (
              <Grid item xs={12} sm={chaves.length > 1 ? 6 : 12} key={v}>
                <TextField select fullWidth size="small" variant="outlined" label={v === "*" ? "Formulário" : `Formulário para ${v}`}
                  value={(f.formularios || {})[v] || ""} onChange={(e) => mudarFase(i, { formularios: { ...(f.formularios || {}), [v]: e.target.value } })}>
                  <MenuItem value="">—</MenuItem>
                  {formularios.map((fo) => <MenuItem key={fo.id} value={fo.id}>{fo.nome}</MenuItem>)}
                </TextField>
              </Grid>
            ))}
            <Grid item xs={12}>
              <TextField fullWidth size="small" variant="outlined" multiline label="Mensagem com o link (opcional)"
                placeholder={"Olá, {nome}! Para seguir no processo, preencha o formulário *{formulario}*:\n{link}"}
                value={f.mensagem || ""} onChange={(e) => mudarFase(i, { mensagem: e.target.value })} />
            </Grid>
            <Grid item xs={12} sm={7}>
              <TextField fullWidth size="small" variant="outlined" multiline label="Agradecimento quando responder"
                placeholder="Obrigado, {nome}! Recebemos suas respostas e em breve entraremos em contato."
                value={f.agradecimento || ""} onChange={(e) => mudarFase(i, { agradecimento: e.target.value })} />
            </Grid>
            <Grid item xs={12} sm={5}>
              <TextField select fullWidth size="small" variant="outlined" label="Ao responder, ir para a etapa" value={f.etapa_ao_responder || ""}
                onChange={(e) => mudarFase(i, { etapa_ao_responder: e.target.value })}>
                <MenuItem value="">Não mudar</MenuItem>
                {etapas.map((et) => <MenuItem key={et} value={et}>{et}</MenuItem>)}
              </TextField>
            </Grid>
          </Grid>
        </div>
      ))}
      <Button startIcon={<AddIcon />} color="primary" onClick={() => mudar({ fases: [...fluxo.fases, novaFase()] })}>Adicionar fase</Button>
    </div>
  );
};


// Campos fixos do card do suporte: vão no protocolo / Base clientes e não podem ser removidos
const FIXOS = [
  ["O.S", "Número da ordem de serviço", "obrigatório para o protocolo"],
  ["Conta", "Busca o cliente na Base clientes (filial e grupo)", "obrigatório para finalizar"],
  ["Tipo", "Escolhido da lista “Tipos de serviço”", "vai no protocolo", "tipo"],
  ["Sistema", "Escolhido da lista “Sistemas”", "vai no protocolo", "sistema"],
  ["Técnico (QRA)", "Base de técnicos; o WhatsApp do técnico identifica sozinho", "vai no protocolo"],
  ["Contato", "Número do WhatsApp da conversa", "automático"],
  ["Aberto", "Quem abriu o card e quando", "automático"],
  ["Status O.S", "Escolhido da lista “Status da O.S” ao finalizar", "ao finalizar", "status"],
];

const FixosSuporte = () => {
  const history = useHistory();
  return (
    <Paper variant="outlined" style={{ padding: 12 }}>
      <Typography variant="subtitle1">Card do suporte</Typography>
      <Typography variant="caption" color="textSecondary" component="div" style={{ marginBottom: 8 }}>
        Campos fixos: aparecem em todo card do suporte e não podem ser removidos. As opções das listas
        (tipo, sistema, status) você altera em Listas.
      </Typography>
      {FIXOS.map(([rotulo, ajuda, regra, lista]) => (
        <div key={rotulo} style={{ display: "flex", gap: 8, alignItems: "center", padding: "6px 0", borderTop: "1px solid rgba(0,0,0,0.08)" }}>
          <LockOutlinedIcon fontSize="small" style={{ opacity: 0.55 }} />
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 600, fontSize: 14 }}>{rotulo}</div>
            <div style={{ fontSize: 12, opacity: 0.7 }}>{`${ajuda} · ${regra}`}</div>
          </div>
          {lista && <Button size="small" onClick={() => history.push("/suporte/listas")}>Editar opções</Button>}
        </div>
      ))}
    </Paper>
  );
};

const CardsFila = () => {
  const c = useStyles();
  const [filas, setFilas] = useState([]);
  const [modelos, setModelos] = useState([]);
  const [listas, setListas] = useState([]);
  const [fila, setFila] = useState(null);
  const [m, setM] = useState(VAZIO);
  const [itensEtapa, setItensEtapa] = useState([]);
  const [remover, setRemover] = useState(false);
  const [criarProprio, setCriarProprio] = useState(false);
  const [formularios, setFormularios] = useState([]);
  useEffect(() => {
    suporteApi.get("/api/formularios", { params: { somente_ativos: true } }).then((r) => setFormularios(r.data)).catch(() => {});
  }, []);

  const carregar = useCallback(async () => {
    try {
      const [f, mo, l] = await Promise.all([
        suporteApi.get("/api/formularios/filas"), suporteApi.get("/api/modelos-card"), suporteApi.get("/api/listas-config"),
      ]);
      setFilas(f.data);
      setModelos(mo.data);
      setListas(l.data);
      setFila((atual) => atual ?? f.data[0]?.id ?? null);
    } catch (err) {
      toast.error(mensagemErro(err));
    }
  }, []);
  useEffect(() => {
    carregar();
  }, [carregar]);

  const existente = modelos.find((x) => x.fila_id === fila);
  // fila sem card próprio usa o card do suporte: aqui se editam os campos adicionais dele (modelo 0)
  const suporte = !existente && !criarProprio;
  const alvo = suporte ? 0 : fila;
  const modeloAlvo = modelos.find((x) => x.fila_id === alvo);
  useEffect(() => setCriarProprio(false), [fila]);
  useEffect(() => {
    if (suporte) setM({ ...VAZIO, ...(modeloAlvo || {}), nome: "Card do suporte", lista_etapas: "", fluxo: null });
    else setM(modeloAlvo ? { ...modeloAlvo, lista_etapas: modeloAlvo.lista_etapas || "" } : VAZIO);
  }, [modeloAlvo, suporte, fila]);
  useEffect(() => {
    if (!m.lista_etapas) return setItensEtapa([]);
    suporteApi.get(`/api/listas/${m.lista_etapas}`).then((r) => setItensEtapa(r.data.filter((x) => x.ativo).map((x) => x.nome)))
      .catch(() => setItensEtapa([]));
  }, [m.lista_etapas]);

  const mudarCampo = (i, d) => setM({ ...m, campos: m.campos.map((x, j) => (j === i ? { ...x, ...d } : x)) });
  const mover = (i, d) => {
    const j = i + d;
    if (j < 0 || j >= m.campos.length) return;
    const cs = [...m.campos];
    [cs[i], cs[j]] = [cs[j], cs[i]];
    setM({ ...m, campos: cs });
  };
  const salvar = async () => {
    try {
      await suporteApi.put(`/api/modelos-card/${alvo}`, { ...m, lista_etapas: m.lista_etapas || null });
      toast.success(suporte ? "Campos do card do suporte salvos" : "Card da fila salvo");
      carregar();
    } catch (err) {
      toast.error(mensagemErro(err));
    }
  };
  const excluir = async () => {
    try {
      await suporteApi.delete(`/api/modelos-card/${fila}`);
      toast.success("A fila voltou a usar o card do suporte");
      carregar();
    } catch (err) {
      toast.error(mensagemErro(err));
    }
  };
  const listasDaFila = listas.filter((l) => !(l.filas || []).length || l.filas.includes(fila));

  return (
    <MainContainer>
      <MainHeader><Title>Cards por fila</Title></MainHeader>
      <Paper variant="outlined" className={c.papel}>
        <Typography variant="body2" color="textSecondary">
          Cada fila do Whaticket pode ter um card próprio na conversa. Fila sem card próprio usa o card do suporte
          (O.S, QRA e protocolo).
        </Typography>
        <div style={{ display: "flex", gap: 6, margin: "12px 0", flexWrap: "wrap" }}>
          {filas.map((q) => (
            <Chip key={q.id} clickable color={q.id === fila ? "primary" : "default"} onClick={() => setFila(q.id)}
              label={`${q.nome}${modelos.some((x) => x.fila_id === q.id) ? ` · ${modelos.find((x) => x.fila_id === q.id).nome}` : " · card do suporte"}`} />
          ))}
        </div>
        {fila && (
          <Grid container spacing={2}>
            <Grid item xs={12} md={5}>
              {suporte ? (
                <>
                  <FixosSuporte />
                  <div style={{ display: "flex", gap: 8, marginTop: 12, flexWrap: "wrap" }}>
                    <Button variant="contained" color="primary" onClick={salvar}>Salvar campos adicionais</Button>
                    <Button onClick={() => setCriarProprio(true)}>Criar card próprio para esta fila</Button>
                  </div>
                </>
              ) : (
              <Paper variant="outlined" style={{ padding: 12 }}>
                <TextField fullWidth variant="outlined" size="small" label="Nome do card" placeholder="Ex.: Candidato"
                  value={m.nome} onChange={(e) => setM({ ...m, nome: e.target.value })} />
                <TextField select fullWidth variant="outlined" size="small" margin="normal" label="Lista de etapas"
                  value={m.lista_etapas} onChange={(e) => setM({ ...m, lista_etapas: e.target.value, etapas_finais: [] })}
                  helperText="O card mostra essas etapas em ordem e o atendente avança.">
                  <MenuItem value="">Sem etapas</MenuItem>
                  {listasDaFila.map((l) => <MenuItem key={l.categoria} value={l.categoria}>{l.nome}</MenuItem>)}
                </TextField>
                {itensEtapa.length > 0 && (
                  <>
                    <Typography variant="subtitle2">Etapas que concluem o card</Typography>
                    <Typography variant="caption" color="textSecondary" component="div">Aparecem como resultado no botão “Concluir”.</Typography>
                    {itensEtapa.map((et) => (
                      <FormControlLabel key={et} label={et} control={
                        <Checkbox size="small" color="primary" checked={(m.etapas_finais || []).includes(et)}
                          onChange={(e) => setM({ ...m, etapas_finais: e.target.checked ? [...(m.etapas_finais || []), et] : m.etapas_finais.filter((x) => x !== et) })} />
                      } />
                    ))}
                  </>
                )}
                <div>
                  <FormControlLabel control={<Switch color="primary" checked={m.ativo !== false} onChange={(e) => setM({ ...m, ativo: e.target.checked })} />}
                    label="Card ativo nesta fila" />
                </div>
                <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                  <Button variant="contained" color="primary" disabled={m.nome.trim().length < 2} onClick={salvar}>Salvar</Button>
                  {existente && <Button onClick={() => setRemover(true)}>Voltar ao card do suporte</Button>}
                  {!existente && <Button onClick={() => setCriarProprio(false)}>Cancelar</Button>}
                </div>
              </Paper>
              )}
            </Grid>
            <Grid item xs={12} md={7}>
              <Typography variant="subtitle1">
                {suporte ? `Campos adicionais do card do suporte (${m.campos.length})` : `Campos do card (${m.campos.length})`}
              </Typography>
              <Typography variant="caption" color="textSecondary" component="div" style={{ marginBottom: 8 }}>
                {suporte
                  ? "Aparecem abaixo dos campos fixos em todo card do suporte (todas as filas sem card próprio). Obrigatório = exigido para finalizar. "
                  : ""}
                Os formulários podem preencher esses campos: no editor do formulário, em “Ao validar, preenche…”.
              </Typography>
              {m.campos.map((cp, i) => (
                <div key={i} className={c.campo}>
                  <Grid container spacing={1} alignItems="center">
                    <Grid item xs={12} sm={5}>
                      <TextField fullWidth size="small" variant="outlined" label="Rótulo" value={cp.rotulo}
                        onChange={(e) => mudarCampo(i, { rotulo: e.target.value })} />
                    </Grid>
                    <Grid item xs={6} sm={4}>
                      <TextField select fullWidth size="small" variant="outlined" label="Tipo" value={cp.tipo}
                        onChange={(e) => mudarCampo(i, { tipo: e.target.value })}>
                        {TIPOS.map(([v, r]) => <MenuItem key={v} value={v}>{r}</MenuItem>)}
                      </TextField>
                    </Grid>
                    <Grid item xs={6} sm={3} style={{ textAlign: "right" }}>
                      <Tooltip title="Subir"><span><IconButton size="small" disabled={i === 0} onClick={() => mover(i, -1)}><ArrowUpwardIcon fontSize="small" /></IconButton></span></Tooltip>
                      <Tooltip title="Descer"><span><IconButton size="small" disabled={i === m.campos.length - 1} onClick={() => mover(i, 1)}><ArrowDownwardIcon fontSize="small" /></IconButton></span></Tooltip>
                      <Tooltip title="Remover"><IconButton size="small" onClick={() => setM({ ...m, campos: m.campos.filter((_, j) => j !== i) })}><DeleteOutlineIcon fontSize="small" /></IconButton></Tooltip>
                    </Grid>
                    {cp.tipo === "lista" && (
                      <Grid item xs={12} sm={5}>
                        <TextField select fullWidth size="small" variant="outlined" label="Lista" value={cp.lista || ""}
                          onChange={(e) => mudarCampo(i, { lista: e.target.value })}>
                          {listasDaFila.map((l) => <MenuItem key={l.categoria} value={l.categoria}>{l.nome}</MenuItem>)}
                        </TextField>
                      </Grid>
                    )}
                    <Grid item xs={12} sm={cp.tipo === "lista" ? 4 : 9}>
                      <TextField select fullWidth size="small" variant="outlined" label="Preenchido por" value={cp.origem || ""}
                        onChange={(e) => mudarCampo(i, { origem: e.target.value || null })}>
                        {ORIGENS.map(([v, r]) => <MenuItem key={v} value={v}>{r}</MenuItem>)}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <FormControlLabel label="Obrigatório" control={
                        <Checkbox size="small" color="primary" checked={!!cp.obrigatorio} onChange={(e) => mudarCampo(i, { obrigatorio: e.target.checked })} />
                      } />
                    </Grid>
                  </Grid>
                </div>
              ))}
              <Button startIcon={<AddIcon />} color="primary"
                onClick={() => setM({ ...m, campos: [...m.campos, { id: "", rotulo: "", tipo: "texto", lista: null, obrigatorio: false, origem: null }] })}>
                Adicionar campo
              </Button>
              {!suporte && <EditorFluxo m={m} setM={setM} etapas={itensEtapa} formularios={formularios} />}
            </Grid>
          </Grid>
        )}
      </Paper>
      <ConfirmationModal title="Voltar ao card do suporte?" open={remover} onClose={() => setRemover(false)} onConfirm={excluir}>
        As conversas desta fila voltam a abrir o card do suporte (O.S, QRA e protocolo). Os cards já abertos continuam guardados.
      </ConfirmationModal>
    </MainContainer>
  );
};

export default CardsFila;
